import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" }); // Scrolls to the top of the window
  }, [pathname]); // Re-runs effect when pathname changes

  return null; // This component doesn't render any UI
}

export default ScrollToTop;
